import { create } from 'zustand';

import AppConfig from '../config/AppConfig';
import BackEndConnection from '../dal/BackEndConnection';

const faqItemStore = create((set) => ({
    faqItems: null,
	faqItem: null,
    currentPage: 1,
    pageSize: 9,
	
	// For SingleMaterial footer page
	videoFaqItems: null,

    updateAttribute: (attributeName, newValue) => {
        set((state) => {
            state.faqItem[attributeName] = newValue;
            return { faqItem: state.faqItem };
        });
    },

    resetFaqItem: () => {
        set((state) => {
            return { faqItem: {} };
        });
    },

    loadAll: (currentPage, pageSize, successCallback, errorCallback) => {
        const payload = { pageSize: pageSize, currentPage: currentPage };
        const url = AppConfig.HOST_URL + 'faq/loadAll';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ faqItems: data }));
            },
            successCallback,
            errorCallback,
        );
    },

    load: (id, successCallback, errorCallback) => {
        const payload = { id: id };
        const url = AppConfig.HOST_URL + 'faq/load';

        return BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ faqItem: data }));
            },
            successCallback,
            errorCallback,
        );
    },

    loadVideoFAQsForFooterTeaser: (id, successCallback, errorCallback) => {
        const payload = { id: id };
        const url = AppConfig.HOST_URL + 'faq/loadVideoFAQs';

        return BackEndConnection.doAxiosPost(
            url,
            payload,
            (data) => {
                set((state) => ({ videoFaqItems: data }));
            },
            successCallback,
            errorCallback,
        );
    },

    create: (data, successCallback, errorCallback) => {
        const payload = { jsonStr: JSON.stringify(data) };
        var url = AppConfig.HOST_URL + 'faq/create';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    update: (data, successCallback, errorCallback) => {
        const payload = { jsonStr: JSON.stringify(data) };
        var url = AppConfig.HOST_URL + 'faq/update';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    delete: (id, successCallback, errorCallback) => {
        const payload = { id: id };
        var url = AppConfig.HOST_URL + 'faq/delete';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },

    updatePositions: (items, successCallback, errorCallback) => {
        let payload = {
            idAndPositionPairs: items.map((item, i) => {
                return { id: item.id, position: item.position };
            }),
        };

        var url = AppConfig.HOST_URL + 'faq/updatePositions';

        BackEndConnection.doAxiosPost(
            url,
            payload,
            () => {
                //noop
            },
            successCallback,
            errorCallback,
        );
    },
}));

export default faqItemStore;
